export const parsedWeekDashboard = (data: any) => {
  const uniqueWeekStart = [...new Set(data.map((item: any) => item.weekStart))];
  let map: any[] = [];
  uniqueWeekStart.map((weekDate) => {
    let filterObj = data.filter((item: any) => item.weekStart === weekDate);

    let ferragemObj = filterObj.filter(
      (item: any) => item.categoryReport === 1
    )[0];
    let chapariaObj = filterObj.filter(
      (item: any) => item.categoryReport === 0
    )[0];

    let newObj = {
      weekStart: filterObj[0].weekStart,
      weekEnd: filterObj[0].weekEnd,
      storeId: filterObj[0].storeId,
      scheduling: filterObj[0].scheduling,
      available: filterObj[0].available,
      exceeded: filterObj[0].exceeded,
      dataShowingFerragem: [
        ferragemObj.scheduling,
        ferragemObj.available,
        ferragemObj.exceeded,
      ],

      dataShowingChaparia: [
        chapariaObj.scheduling,
        chapariaObj.available,
        chapariaObj.exceeded,
      ],
      // dataShowingChaparia: filterObj[1].dataShowing,
      // dataShowingFerragem: [50, 30, 20],
      categoryReport: 1,
    };
    map.push(newObj);
  });
  return map;
};

export const parsedDayDashboard = (data: any) => {
  const uniqueDayStart = [...new Set(data.map((item: any) => item.day))];
  let map: any[] = [];

  uniqueDayStart.map((dayDate) => {
    let filterObj = data.filter((item: any) => item.day === dayDate);
    let ferragemObj = filterObj.filter(
      (item: any) => item.categoryReport === 1
    )[0];
    let chapariaObj = filterObj.filter(
      (item: any) => item.categoryReport === 0
    )[0];
    let newObj = {
      day: filterObj[0].day,
      storeId: filterObj[0].storeId,
      scheduling: filterObj[0].scheduling,
      available: filterObj[0].available,
      exceeded: filterObj[0].exceeded,
      // dataShowingFerragem: filterObj[0].dataShowing,
      // dataShowingChaparia: filterObj[1].dataShowing,
      dataShowingFerragem: [
        ferragemObj.scheduling,
        ferragemObj.available,
        ferragemObj.exceeded,
      ],

      dataShowingChaparia: [
        chapariaObj.scheduling,
        chapariaObj.available,
        chapariaObj.exceeded,
      ],
      categoryReport: 1,
    };
    map.push(newObj);
  });
  return map;
};
